import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";

interface EmptyStateProps {
  isDraft: boolean;
  isFilteredByTopic?: boolean;
  isPastEvents: boolean;
}

export const NoUpcomingEvents = ({
  isPastEvents,
  isDraft,
  isFilteredByTopic,
}: EmptyStateProps) => {
  let translationKey = "no_upcoming";
  if (isPastEvents) {
    translationKey = "no_previous";
  } else if (isDraft) {
    translationKey = "no_draft";
  }
  const title = t(["events", translationKey]);
  const description = isFilteredByTopic
    ? t(["events", `${translationKey}_with_topic_description`])
    : t(["events", `${translationKey}_description`]);

  return (
    <div className="px-2 py-4 md:p-0">
      <div
        className={classNames(
          "border-primary bg-primary flex w-full flex-col justify-center rounded-2xl border py-20 text-center md:h-auto md:w-auto",
        )}
      >
        <Typography.TitleSm weight="semibold">{title}</Typography.TitleSm>
        <div className="mt-4">
          <Typography.LabelMd>{description}</Typography.LabelMd>
        </div>
      </div>
    </div>
  );
};
